import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { environment } from '../../../environments/environment';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatInputModule, MatButtonModule, FormsModule, RouterModule],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent {
  email = signal('');
  tipo = '';

  mensagemSucesso = signal('');
  mensagemErro = signal('');

  private route = inject(ActivatedRoute);
  private http = inject(HttpClient);

  constructor() {
    this.tipo = this.route.snapshot.data['tipo'] || 'senha';
    console.log('forgot-password carregado com sucesso!');
}

  emailValido(): boolean {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(this.email());
  }

  solicitarInformacao() {
  if (!this.emailValido()) {
    alert("Por favor, insira um e-mail vÃ¡lido.");
    return;
  }

  const apiUrl = this.tipo === 'senha' 
    ? `${environment.apiUrl}/auth/forgot-password`
    : `${environment.apiUrl}/auth/forgot-username`;

  this.http.post(apiUrl, { email: this.email() }).subscribe({
    next: () => {
      alert(`Se o e-mail foi informado corretamente, um link de redefiniÃ§Ã£o de senha foi enviado para: ${this.email()}`);
      this.email.set('');
    },
    error: () => {
      alert("Erro ao solicitar informaÃ§Ãµes. Verifique o e-mail informado.");
    }
  });
}
}
